<div #mainContainer class="main-container">
  <app-header (openMenu)="displayMask($event)" [closePopups]="closePopups" [user]="user"> </app-header>
  <div class="header-content-separator"></div>

  <ng-container *ngIf="!isStandAlone; else standAlone">
    <ng-container *ngIf="state !== 'error'; else error">
      <ng-container *ngIf="state === 'loading' || !currentProject">
        <div id="circle-container" class="circle-container">
          <div class="circle-loader"></div>
        </div>
      </ng-container>

      <div #mainContent class="main-content" *ngIf="currentProject">
        <div *ngIf="isMenuOpen" (click)="inClosePopups()" class="mask"></div>
        <div class="router-outlet">
          <router-outlet (activate)="componentAdded($event)"></router-outlet>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #standAlone>
    <div #mainContent class="main-content">
      <div class="router-outlet">
        <router-outlet (activate)="componentAdded($event)"></router-outlet>
      </div>
    </div>
  </ng-template>

  <ng-template #error>
    <app-error class="main-content" [message]="errorMessage" [errorLink]="errorLink"></app-error>
  </ng-template>
</div>
